// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `main{

}

.styles_container__U51HK{
    width: var(--container-width-md);
    max-width: 1920px;
    margin: 80px auto 119px auto ;
    
}

.styles_container__U51HK > div > h1 {
    font-style: normal;
    font-weight: 420;
    font-size: 40px;
    line-height: 57px;
    text-align: center;
}

.styles_container__U51HK > div {
    margin-bottom: 64px;
}

.styles_section__cJesZ{
    width: 1075px;
    margin: auto;
}

.styles_section__cJesZ > div > ul {
    list-style: none;
    font-style: normal;
    font-weight: 490;
    font-size: 22px;
    line-height: 31px;
}

.styles_section__cJesZ > div > ul > li{
    margin-bottom: 20px;
}

.styles_form__TvXwE {
    width: 1075px;
    height: 447px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.styles_sectionImage__zBjAR{
    display: flex;
    justify-content: center;
    
}
.styles_sectionImage__zBjAR img{
    width: 100%;
}


.styles_form__TvXwE input{
    display: none;
}

.styles_form__TvXwE label{
    font-style: normal;
    font-weight: 500;
    font-size: 22px;
    line-height: 31px;
    color: #E0001B;
}

.styles_section__cJesZ > ul {
    /* list-style: none;
    list-style: none; */
    font-style: normal;
    font-weight: 490;
    font-size: 22px;
    line-height: 31px;
}

@media screen and (max-width: 1280px ){

    .styles_section__cJesZ{
        width: clamp(745px,90vw,1075px);

    }
    .styles_form__TvXwE {
        width: clamp(745px,90vw,1075px);

    }
}

@media screen and (max-width: 820px ){

    .styles_section__cJesZ{
        width: clamp(337px,90vw,745px);

    }
    .styles_form__TvXwE {
        width: clamp(334px,90vw,745px);

    }

    .styles_container__U51HK{
       
        margin: 80px auto 44px auto ;
        
    }

    .styles_title__wfYrl {
        text-align: center;
        padding: 0 20px;
        margin-bottom: 20px;
        font-size: 30px;
      }
}

@media screen and (max-width: 480px ){

    .styles_section__cJesZ{
        width: clamp(337px,90vw,745px);

    }
    .styles_form__TvXwE {
        width: clamp(334px,90vw,745px);

    }

    .styles_container__U51HK{
       
        margin: 80px auto 44px auto ;
        
    }

    .styles_title__wfYrl {
        text-align: center;
        padding: 0 20px !important;
        margin-bottom: 20px !important;
        font-size: 30px !important;
        line-height: normal !important;
      }
}

.styles_authBtnGetStarted__zOxH7 {
    width: 120px;
    height: 80px;
    border-radius: 10px;
    font-size: 20px;
    font-weight: 500;
    margin: 20px;
    padding: 10px;
    font-family: 'Brandon Grotesque';
    cursor: pointer;
    background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);
    color: white;
  
  }
  .styles_link__Dgdd8{
    font-family: 'Brandon Grotesque', sans-serif;
    font-size: 22px;
    background: transparent;
  }

  .styles_title__wfYrl {
    text-align: center;
    padding: 0 100px;
    margin-bottom: 40px;
    font-size: 40px;
  }

  .styles_subtitle__k4Jua {
    text-align: center;
    margin: 20px 0;
  }

  .styles_list__aZPFR {
    margin-top: 20px;
    margin-left: 40px;
    margin-bottom: 40px;
  }`, "",{"version":3,"sources":["webpack://./src/pages/AboutUsPage/styles.module.css"],"names":[],"mappings":"AAAA;;AAEA;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,6BAA6B;;AAEjC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,uBAAuB;;AAE3B;AACA;IACI,WAAW;AACf;;;AAGA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI;uBACmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;;IAEI;QACI,+BAA+B;;IAEnC;IACA;QACI,+BAA+B;;IAEnC;AACJ;;AAEA;;IAEI;QACI,8BAA8B;;IAElC;IACA;QACI,8BAA8B;;IAElC;;IAEA;;QAEI,4BAA4B;;IAEhC;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,mBAAmB;QACnB,eAAe;MACjB;AACN;;AAEA;;IAEI;QACI,8BAA8B;;IAElC;IACA;QACI,8BAA8B;;IAElC;;IAEA;;QAEI,4BAA4B;;IAEhC;;IAEA;QACI,kBAAkB;QAClB,0BAA0B;QAC1B,8BAA8B;QAC9B,0BAA0B;QAC1B,8BAA8B;MAChC;AACN;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,gCAAgC;IAChC,eAAe;IACf,wFAAwF;IACxF,YAAY;;EAEd;EACA;IACE,4CAA4C;IAC5C,eAAe;IACf,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB","sourcesContent":["main{\n\n}\n\n.container{\n    width: var(--container-width-md);\n    max-width: 1920px;\n    margin: 80px auto 119px auto ;\n    \n}\n\n.container > div > h1 {\n    font-style: normal;\n    font-weight: 420;\n    font-size: 40px;\n    line-height: 57px;\n    text-align: center;\n}\n\n.container > div {\n    margin-bottom: 64px;\n}\n\n.section{\n    width: 1075px;\n    margin: auto;\n}\n\n.section > div > ul {\n    list-style: none;\n    font-style: normal;\n    font-weight: 490;\n    font-size: 22px;\n    line-height: 31px;\n}\n\n.section > div > ul > li{\n    margin-bottom: 20px;\n}\n\n.form {\n    width: 1075px;\n    height: 447px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.sectionImage{\n    display: flex;\n    justify-content: center;\n    \n}\n.sectionImage img{\n    width: 100%;\n}\n\n\n.form input{\n    display: none;\n}\n\n.form label{\n    font-style: normal;\n    font-weight: 500;\n    font-size: 22px;\n    line-height: 31px;\n    color: #E0001B;\n}\n\n.section > ul {\n    /* list-style: none;\n    list-style: none; */\n    font-style: normal;\n    font-weight: 490;\n    font-size: 22px;\n    line-height: 31px;\n}\n\n@media screen and (max-width: 1280px ){\n\n    .section{\n        width: clamp(745px,90vw,1075px);\n\n    }\n    .form {\n        width: clamp(745px,90vw,1075px);\n\n    }\n}\n\n@media screen and (max-width: 820px ){\n\n    .section{\n        width: clamp(337px,90vw,745px);\n\n    }\n    .form {\n        width: clamp(334px,90vw,745px);\n\n    }\n\n    .container{\n       \n        margin: 80px auto 44px auto ;\n        \n    }\n\n    .title {\n        text-align: center;\n        padding: 0 20px;\n        margin-bottom: 20px;\n        font-size: 30px;\n      }\n}\n\n@media screen and (max-width: 480px ){\n\n    .section{\n        width: clamp(337px,90vw,745px);\n\n    }\n    .form {\n        width: clamp(334px,90vw,745px);\n\n    }\n\n    .container{\n       \n        margin: 80px auto 44px auto ;\n        \n    }\n\n    .title {\n        text-align: center;\n        padding: 0 20px !important;\n        margin-bottom: 20px !important;\n        font-size: 30px !important;\n        line-height: normal !important;\n      }\n}\n\n.authBtnGetStarted {\n    width: 120px;\n    height: 80px;\n    border-radius: 10px;\n    font-size: 20px;\n    font-weight: 500;\n    margin: 20px;\n    padding: 10px;\n    font-family: 'Brandon Grotesque';\n    cursor: pointer;\n    background: linear-gradient(90deg, var(--color-primary) 0%, var(--color-secundary) 100%);\n    color: white;\n  \n  }\n  .link{\n    font-family: 'Brandon Grotesque', sans-serif;\n    font-size: 22px;\n    background: transparent;\n  }\n\n  .title {\n    text-align: center;\n    padding: 0 100px;\n    margin-bottom: 40px;\n    font-size: 40px;\n  }\n\n  .subtitle {\n    text-align: center;\n    margin: 20px 0;\n  }\n\n  .list {\n    margin-top: 20px;\n    margin-left: 40px;\n    margin-bottom: 40px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__U51HK`,
	"section": `styles_section__cJesZ`,
	"form": `styles_form__TvXwE`,
	"sectionImage": `styles_sectionImage__zBjAR`,
	"title": `styles_title__wfYrl`,
	"authBtnGetStarted": `styles_authBtnGetStarted__zOxH7`,
	"link": `styles_link__Dgdd8`,
	"subtitle": `styles_subtitle__k4Jua`,
	"list": `styles_list__aZPFR`
};
export default ___CSS_LOADER_EXPORT___;
